module.exports = __webpack_public_path__ + "img/know.958553a9.png";